<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <b-card title="Contact Us" type="secondary" shadow header-classes="bg-white pb-5"
                    body-classes="px-lg-5 py-lg-5">
                    <b-card-text>
                        <h4>Call Us</h4>
                        +27 87 702 0660 / +27 67 740 5859<br /><br />
                        <h4>Whatsapp Us</h4>
                        +27 67 740 5859<br /><br />
                        <h4>Email Us</h4>
                        info@umbai.co.za<br /><br />
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </div>
</div>